import { Parameter, Parameter_Plus } from "src/app/shared/models/form-model/models/form-controlls.model";


export class Order {
    Id:Number = 0;
  orderNumber: string;
  status: string;
  statusDes: string;
  oldTechTime?: number;
  newTechTime?: number;
  notes?: string;
  details?: string;
  detailsS?: string;
  public start:number;
  oldTechParams?: Parameter_Plus[];
  newTechParams?: Parameter_Plus[];
  ParamsDif?: Parameter_Dif[];
  sync: boolean = false;
}
export class OrderSend {
    Id:Number = 0;
  orderNumber: string;
  status: string;
  statusDes: string;
  oldTechTime?: number;
  newTechTime?: number;
  notes?: string;
  details?: string;
  detailsS?: string;
  public start:number;
  oldTechParams?: string;
  newTechParams?: string;
  ParamsDif?: string;
}

export class Parameter_Dif {
  Key: any = 'X';
  Value: any;
  Position?: number;
  Module?: number;
  Type?: any;
  Diffrence?:string;
}